<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bibrh0/tc-custom/9780062015471.jpg?1737195673309" alt="This image is the cover for the book Secrets Sisters Keep"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secrets Sisters Keep
      </h1>
      <p class="bookDescription body article font2">
        <p>“Abby Drake is a masterful storyteller.”<br/>—Sue Margolis, author of <i>Gucci, Gucci, Coo</i></p><p></p><p></p><p>The secrets sisters keep can be startling—and in the hands of Abby Drake, author of <i>Perfect Little Ladies </i>and<i> Good Little Wives</i>, they can be outrageous, eye-opening, wickedly smart and wildly funny. With <i>The Secrets Sisters Keep, </i>Drake once again takes women’s fiction far beyond common chick lit—delighting readers with a deeply satisfying story of four sisters gathering at a rich uncle’s home  to celebrate his birthday. But they’ll have to find the old man first, since he’s inconveniently gone missing. If you like Allison Pearson, Jennifer Weiner, and Jennifer Crusie, you will love this fresh and surprising story of sibling rivalry, fate, disputed fortunes,<i></i>and <i>The Secrets Sisters Keep.</i></p><p></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Abby Drake
      </h2>
      
      <p class="authorDescription body article"><P>Abby Drake is a <I>Mayflower</I> descendant and has one sister with whom she's kept lots of secrets. She's the author of <I>Good Little Wives</I> and <I>Perfect Little Ladies</I>. Drake lives in Amherst, Massachusetts, but enjoys wandering off from time to time.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f26d644c